import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { DynamicFormField } from '@teamfoster/dynamic-forms';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-form-input-v2',
  templateUrl: './form-input-v2.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class FormInputV2Component implements OnInit, OnDestroy {
  config!: DynamicFormField;
  group!: UntypedFormGroup;
  private _unsubscribe = new Subject<void>();

  constructor(private cd: ChangeDetectorRef) {}

  ngOnInit(): void {
    // status updates not updating dom.. bugfix
    this.group
      .get(this.config.name)
      ?.statusChanges.pipe(takeUntil(this._unsubscribe))
      .subscribe(a => {
        this.cd.markForCheck();
      });
  }

  get iconClass() {
    const prefixClass = this.config.matPrefix ? 'has--prefix-icon' : '';
    const suffixClass = this.config.matSuffix ? 'has--suffix-icon' : '';

    return `${prefixClass} ${suffixClass}`;
  }

  ngOnDestroy(): void {
    this._unsubscribe.next();
    this._unsubscribe.complete();
  }
}
